import util from '../util';

export const ROLE = 'ROLE';
export const ROLES = 'ROLES';
export const ROLE_CREATE = 'ROLE_CREATE';
export const ROLE_UPDATE = 'ROLE_UPDATE';
export const RESET_ROLE = 'RESET_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
export const RESOURCES = 'RESOURCES';

export const ROLES_REQUEST = util.requestType(ROLES);
export const ROLES_SUCCESS = util.successType(ROLES);
export const ROLES_FAILURE = util.failureType(ROLES);

export const RESOURCES_REQUEST = util.requestType(RESOURCES);
export const RESOURCES_SUCCESS = util.successType(RESOURCES);
export const RESOURCES_FAILURE = util.failureType(RESOURCES);

export const ROLE_REQUEST = util.requestType(ROLE);
export const ROLE_SUCCESS = util.successType(ROLE);
export const ROLE_FAILURE = util.failureType(ROLE);

export const CREATE_ROLE_REQUEST = util.requestType(ROLE_CREATE);
export const CREATE_ROLE_SUCCESS = util.successType(ROLE_CREATE);
export const CREATE_ROLE_FAILURE = util.failureType(ROLE_CREATE);

export const UPDATE_ROLE_REQUEST = util.requestType(ROLE_UPDATE);
export const UPDATE_ROLE_SUCCESS = util.successType(ROLE_UPDATE);
export const UPDATE_ROLE_FAILURE = util.failureType(ROLE_UPDATE);

export const DELETE_ROLE_REQUEST = util.requestType(DELETE_ROLE);
export const DELETE_ROLE_SUCCESS = util.successType(DELETE_ROLE);
export const DELETE_ROLE_FAILURE = util.failureType(DELETE_ROLE);
